<template>
    <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
        <div id="app">
            <v-app id="inspire">
                <v-card v-model="show" color="#FFFF99">
                    <v-card-title>
                        <v-icon large left>mdi-wrench-clock</v-icon>
                        <h6>Cargar Documentos y Planos</h6>
                        <v-spacer></v-spacer>
                        <div>
                            <v-btn icon @click="show = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="12" md="4" sm="6">
                                Cliente: {{ cliente }}
                            </v-col>
                            <v-col cols="12" md="6" sm="6">
                                Obra: {{ obra }}
                            </v-col>
                            <v-col cols="12" md="2" sm="6">
                                Codificación: {{ codigo }}
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" md="4" sm="4">
                                Texto contenido: {{ descr }}
                            </v-col>
                            <v-col cols="12" md="3" sm="4">
                                Cantidad de Documentos: {{ listadoFiltrado.length }}
                            </v-col>
                            <v-col cols="12" md="2" sm="4">
                                <v-select dense outlined :items="listadotipo" item-text="tipodescripcion"
                                    item-value="tipoplano" label="Filtrar por tipo:" v-model="tipo" clearable
                                    hide-details="auto" class="font-class-name" />
                            </v-col>
                            <v-col cols="12" md="2" sm="4">
                                <v-select dense outlined :items="listadoestado" item-text="valor" item-value="texto"
                                    clearable label="Filtrar por estado:" v-model="estado" hide-details="auto"
                                    class="font-class-name" />
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-card>
                    <v-card-text>
                        <v-data-table dense :headers="headers" :items="listadoFiltrado" :single-expand="true"
                            locale="es-ar" class="elevation-1" :items-per-page="2000" hide-default-footer
                            :loading="loadtable" fixed-header max-height="280"
                            loading-text="Cargando... Espere por favor" no-data-text="No hay datos disponibles">
                            <template v-slot:item.estado="{ item }">
                                <div :style="{ color: text_color(item) }">
                                    {{ item.estado }}
                                </div>
                            </template>
                            <template v-slot:item.nomplano="{ item }">
                                <div class="celda-color" :style="{ backgroundColor: row_color(item) }">
                                    {{ item.nomplano }}
                                </div>
                            </template>
                            <template v-slot:item.archivootro="{ item }">
                                {{ item.archivootro }}.{{ item.tipoarchivo }}
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
                <v-card>
                    <v-card-text color="#FFFF99">
                        <v-data-table dense :headers="headersnuevo" :items="listadonuevo" :single-expand="true"
                            locale="es-ar" class="elevation-1" :items-per-page="2000" hide-default-footer>
                            <template v-slot:item.tipoplano="{ item }">
                                <v-row dense>
                                    <v-col cols="12" sm="12" md="8">
                                        <v-select dense class="font-class-name v-select-mini select-corto"
                                            v-model="item.tipoplano" :items="listadotipo" outlined
                                            item-text="tipodescripcion" item-value="tipoplano" hide-details></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-checkbox dense v-model="item.opcionotro" true-value="ON" false-value=""
                                            label="Otro" hide-details></v-checkbox>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="8">
                                        <v-text-field v-if="item.opcionotro == 'ON'" dense v-model="item.nomplano"
                                            class="font-class-name" outlined hide-details></v-text-field>
                                    </v-col>
                                </v-row>
                            </template>
                            <template v-slot:item.archivootro="{ item }">
                                <!-- <v-row dense>
                                    <v-col cols="12" sm="12" md="12"> -->
                                <v-select dense class="font-class-name v-select-mini select-corto"
                                    v-model="item.archivo" :items="listadoarchivo" outlined item-text="nombre"
                                    item-value="valor" hide-details></v-select>
                                <!-- </v-col> -->
                                <!-- <v-col cols="12" sm="12" md="12"> -->
                                <v-text-field v-if="item.archivo == 'otro'" dense v-model="item.otro"
                                    class="font-class-name" outlined hide-details></v-text-field>
                                <!-- </v-col>
                                </v-row> -->
                            </template>
                            <template v-slot:item.descrplano="{ item }">
                                <v-text-field dense v-model="item.descrplano" class="font-class-name" outlined
                                    hide-details></v-text-field>
                            </template>
                            <template v-slot:item.tipoarchivo="{ item }">
                                <v-select dense class="font-class-name v-select-mini select-corto"
                                    v-model="item.tipoarchivo" :items="listadoextension" outlined item-text="extension"
                                    item-value="extension" hide-details></v-select>
                            </template>
                            <template v-slot:item.nomproyecto="{ item }">
                                <v-select dense class="font-class-name v-select-mini select-corto"
                                    v-model="item.nomproyecto" :items="proyectistas" outlined item-text="nombre"
                                    item-value="codigo" hide-details></v-select>
                            </template>
                            <template v-slot:item.nomdibujo="{ item }">
                                <v-select dense class="font-class-name v-select-mini select-corto"
                                    v-model="item.nomdibujo" :items="proyectistas" outlined item-text="nombre"
                                    item-value="codigo" hide-details></v-select>
                            </template>
                            <template v-slot:item.orden="{ item }">
                                <v-text-field dense v-model="item.orden" class="font-class-name" outlined
                                    hide-details></v-text-field>
                            </template>
                            <template v-slot:item.revision="{ item }">
                                <v-text-field dense v-model="item.revision" class="font-class-name" outlined
                                    hide-details></v-text-field>
                            </template>
                            <template v-slot:item.fecha="{ item }">
                                <v-text-field dense v-model="item.fecha" class="font-class-name" outlined
                                    hide-details></v-text-field>
                            </template>
                            <template v-slot:item.avance="{ item }">
                                <v-checkbox dense v-model="item.avance" class="font-class-name"
                                    hide-details></v-checkbox>
                            </template>
                        </v-data-table>
                        <v-btn dense class="mx-2" dark small color="orange" @click="addRow()">Agregar fila</v-btn>
                    </v-card-text>
                </v-card>
                <v-card v-model="show" color="#FFFF99">
                    <v-card-actions>
                        <!-- BOTONES -->
                        <v-divider class="mt-2 mb-4" />
                        <v-row justify="end" dense>
                            <v-btn color="primary" dark depressed @click="guardar" :disabled="deshabilitar">
                                Guardar
                            </v-btn>
                        </v-row>
                    </v-card-actions>
                </v-card>
            </v-app>
        </div>
    </v-dialog>
</template>

<style scoped>
.v-select-mini .v-input__control {
    min-height: 30px !important;
}

.v-select-mini .v-input__slot {
    padding: 0 2px !important;
}

.v-select-mini .v-select__selection {
    font-size: 12px;
    line-height: 10px;
}

.v-select-mini .v-icon {
    font-size: 18px;
}

.select-corto {
    max-width: 180px;
    /* ajustá este valor */
}

.select-corto .v-input__control {
    min-height: 30px !important;
}

.font-class-name2 {
    font-size: 12px !important;
}

.font-class-name {
    font-size: 12px;
}

::v-deep .v-data-table .v-data-table__wrapper td {
    font-size: 12px !important;
    padding: 2px 4px !important;
}

::v-deep .v-data-table .v-data-table-header tr th {
    font-size: 12px !important;
    padding: 2px 4px !important;
}

.celda-color {
    width: 100%;
    height: 100%;
    padding: 4px 8px;
    box-sizing: border-box;
}

.v-checkbox ::v-deep label {
    display: flex;
    align-items: center;
    margin: 0 !important;
}
</style>
<script>
import axios from "../../../axios-auth";
//import Ver from "../Documentos/Listadodoc.vue";
import moment from "moment";

export default {
    //   components: { Ver },
    data: (vm) => ({
        usuario: "",
        deshabilitar: false,
        editedItem: {
            fact: "",
            codgral: "",
            empresa: "",
            codoc: "",
            responsable: "",
        },
        editedIndex: -1,
        listado: [],
        listadoref: [],
        listadotipo: [],
        extensiones: [],
        proyectistas: [],
        listadonuevo: [{ tipoplano: "", archivo: "", descrplano: "", tipoarchivo: "", nomproyecto: "", nomdibujo: "", orden: "", revision: "", fecha: "", avance: "" },
        { tipoplano: "", archivo: "", descrplano: "", tipoarchivo: "", nomproyecto: "", nomdibujo: "", orden: "", revision: "", fecha: "", avance: "" },
        { tipoplano: "", archivo: "", descrplano: "", tipoarchivo: "", nomproyecto: "", nomdibujo: "", orden: "", revision: "", fecha: "", avance: "" },
        { tipoplano: "", archivo: "", descrplano: "", tipoarchivo: "", nomproyecto: "", nomdibujo: "", orden: "", revision: "", fecha: "", avance: "" },
        { tipoplano: "", archivo: "", descrplano: "", tipoarchivo: "", nomproyecto: "", nomdibujo: "", orden: "", revision: "", fecha: "", avance: "" },
        { tipoplano: "", archivo: "", descrplano: "", tipoarchivo: "", nomproyecto: "", nomdibujo: "", orden: "", revision: "", fecha: "", avance: "" },
        { tipoplano: "", archivo: "", descrplano: "", tipoarchivo: "", nomproyecto: "", nomdibujo: "", orden: "", revision: "", fecha: "", avance: "" },
        { tipoplano: "", archivo: "", descrplano: "", tipoarchivo: "", nomproyecto: "", nomdibujo: "", orden: "", revision: "", fecha: "", avance: "" },
        ],
        listadoestado: [
            { texto: "T", valor: "Con actividad" },
            { texto: "X", valor: "Sin actividad" },
            { texto: "A", valor: "Enviados" },
            { texto: "D", valor: "Aprobados" },
            { texto: "C", valor: "Aprobados c/obs" },
            { texto: "B", valor: "Observados" },
            { texto: "R", valor: "Recibidos (Apr, Apr c/obs, Obs)" },
        ],
        listadotipo: [],
        listadoextension: [],
        listadoarchivo: [{ nombre: "ICSSA", valor: "ICSSA" },
        { nombre: "OTRO", valor: "otro" },
        ],
        estado: "",
        tipo: "",
        showEditar: false,
        loadtable: false,
        headers: [
            {
                text: "Nombre",
                align: "start",
                sortable: false,
                value: "nomplano",
            },
            { text: "Revisión", value: "revision", sortable: false },
            { text: "Descripción", value: "descrplano", sortable: false },
            { text: "Archivo", value: "archivootro", sortable: false },
            { text: "N° OT", value: "orden", sortable: false },
            { text: "Proyectó", value: "nombreproyecto", sortable: false },
            { text: "Dibujó", value: "nombredibujo", sortable: false },
            { text: "Fecha", value: "fecha", sortable: false },
            { text: "Estado", value: "estado", sortable: false },
            { text: "% de avance", value: "avance", sortable: false },
        ],
        headersnuevo: [
            {
                text: "Tipo Doc.",
                align: "start",
                sortable: false,
                value: "tipoplano",
            },
            { text: "Archivo", value: "archivootro", width: "8%", sortable: false },
            { text: "Descripción", value: "descrplano", width: "25%", sortable: false },
            { text: "Extensión", value: "tipoarchivo", sortable: false },
            { text: "Proyectó", value: "nomproyecto", sortable: false },
            { text: "Dibujó", value: "nomdibujo", sortable: false },
            { text: "N° OT", value: "orden", width: "5%", sortable: false },
            { text: "Revisión", value: "revision", width: "3%", sortable: false },
            { text: "Fecha", value: "fecha", width: "8%", sortable: false },
            { text: "Avance", value: "avance", width: "3%", sortable: false },
        ],

    }),

    computed: {
        show: {
            get() {
                if (this.visible == true) {
                    this.cargarListados();
                    this.listadotipos();
                    this.listadoextensiones();
                    this.listadoproyectistas();
                }

                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.vaciarModels();
                    this.$emit("close");
                }
            },
        },
        listadoFiltrado() {
            return this.listado.filter(item => {

                /* =====================
                   FILTRO POR TIPO
                ====================== */
                if (this.tipo && item.tipoplano !== this.tipo) {
                    return false;
                }

                /* =====================
                   FILTRO POR ESTADO
                ====================== */
                if (!this.estado) return true;

                const estado = item.estado;

                switch (this.estado) {
                    case "T": // Con actividad
                        return estado !== null && estado !== "";

                    case "X": // Sin actividad
                        return estado === null || estado === "";

                    case "A": // Enviados
                        return estado === "A";

                    case "D": // Aprobados
                        return estado === "D";

                    case "C": // Aprobados c/obs
                        return estado === "C";

                    case "B": // Observados
                        return estado === "B";

                    case "R": // Recibidos (B, C, D)
                        return ["B", "C", "D"].includes(estado);

                    default:
                        return true;
                }
            });
        }

    },
    props: ["visible", "numcliente", "numobra", "proyectista", "descr", "avance", "cliente", "obra", "codigo"],

    methods: {
        addRow(flag) {
            this.listadonuevo.push({ tipoplano: "", archivo: "", descrplano: "", tipoarchivo: "", nomproyecto: "", nomdibujo: "", orden: "", revision: "", fecha: "", avance: "" },)
        },

        text_color(item) {
            if (item.estado == "ENV") {
                return "#0000FF";
            }
            if (item.estado == "OBS") {
                return "#FF0000";
            }
            if (item.estado == "AcO") {
                return "#800080";
            }
            if (item.estado == "APR") {
                return "#008000";
            }
            else {
                return "#000000";
            }
        },
        row_color(item) {
            if (item.tipoplano == "E") {
                return "#FFCC99";
            }
            if (item.tipoplano == "C") {
                return "#FFFF99";
            }
            if (item.tipoplano == "M") {
                return "#99FF66";
            }
            if (item.tipoplano == "B") {
                return "#CC99FF";
            }
            if (item.tipoplano == "D") {
                return "#99FFCC";
            }
            if (item.tipoplano == "T") {
                return "#99CCFF";
            }
            if (item.tipoplano == "P") {
                return "#FF99FF";
            }
            if (item.tipoplano == "F") {
                return "#FFFF66";
            }
            if (item.tipoplano == "N") {
                return "#9999FF";
            }
            if (item.tipoplano == "X") {
                return "#FF9933";
            }
            if (item.tipoplano == "O") {
                return "#CCCCCC";
            }
            if (item.tipoplano == "AI") {
                return "#99FF99";
            }
            if (item.tipoplano == "PR") {
                return "#CCFF66";
            }
            if (item.tipoplano == "PT") {
                return "#CCFF66";
            }
            if (item.tipoplano == "A") {
                return "#CCCCFF";
            }
        },

        listadotipos() {
            let self = this;
            axios
                .get("/Ingenieria/Listadotipos?", {

                })
                .then((response) => {
                    self.listadotipo = response.data;
                })
                .catch((error) => {
                    self.listadotipo = [];
                    console.log(error);
                });
        },

        listadoproyectistas() {
            let self = this;
            axios
                .get("/Ingenieria/Listadoproyectistas?")
                .then((response) => {
                    self.proyectistas = response.data;
                })
                .catch((error) => {
                    self.proyectistas = [];
                    console.log(error);
                });
        },

        listadoextensiones() {
            let self = this;
            axios
                .get("/Ingenieria/Listadoextension?", {

                })
                .then((response) => {
                    self.listadoextension = response.data;
                })
                .catch((error) => {
                    self.listadoextension = [];
                    console.log(error);
                });
        },

        cargarListados() {
            this.loadtable = true;
            let self = this;
            axios
                .get("/Ingenieria/Listadoplanos?", {
                    params: {
                        numobra: self.numobra,
                        numcliente: self.numcliente,
                        avance: self.avance,
                        proyectista: self.proyectista,
                        descrplano: self.descr,
                    },
                })
                .then((response) => {
                    self.listado = response.data;
                    self.loadtable = false;
                })
                .catch((error) => {
                    self.listado = [];
                    console.log(error);
                });

        },

        guardar() {
            this.$swal({
                title: "Guardar Documentos",
                text: "¿Desea guardar los datos?",
                icon: "success",
                type: "success",
                showCancelButton: true,
                background: "#ececec",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    this.deshabilitar = true;
                    this.listadonuevo.forEach((element) => {
                        if (element.descrplano != "" && element.descrplano != null) {
                            if (element.archivo == "ICSSA") {
                                element.archivootro = "-";
                            }
                            else {
                                element.archivootro = element.otro;
                                element.nomplano = element.archivootro;
                            }
                            if (element.opcionotro == "ON") {
                                element.tipoplano = "O";
                            }
                            this.listadoref.push({
                                numcliente: this.numcliente,
                                numobra: this.numobra,
                                descrplano: element.descrplano,
                                tipoplano: element.tipoplano,
                                nomplano: element.nomplano,
                                archivootro: element.archivootro,
                                tipoarchivo: element.tipoarchivo,
                                nomproyecto: element.nomproyecto,
                                nomdibujo: element.nomdibujo,
                                orden: element.orden,
                                revision: element.revision,
                                fecha: element.fecha,
                                avance: element.avance,

                            });
                        }
                    });


                    let self = this;
                    axios
                        .post("/Ingenieria/GuardarPlanos", self.listadoref)
                        .then((response) => {

                            self.showAlert({
                                icon: "success",
                                title: "Documentos guardados con éxito",
                                vm: self,
                            });
                            self.vaciarModels();
                            self.$emit("close");
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                }
            });
        },
        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 2000,
            });
        },
        vaciarModels() {
            // this.listado = [];
            const initialState = this.$options.data.call(this);

            Object.keys(initialState).forEach((key) => {
                this[key] = initialState[key];
            });
            // this.listadonuevo = [];


        },
    },
};
</script>
